export { default as ProductionVendorSlot } from './ProductionVendorSlot';
